import { FC } from 'react';
import styled from 'styled-components';

import { FileTypeIcon } from '@/shared/components/FileTypeIcon';
import { COLORS } from '@/shared/constants/colors';

import { FileInfo } from '../types';

type StatusProps = {
  fileInfo: FileInfo;
};

export const Status: FC<StatusProps> = ({ fileInfo }) => {
  return (
    <Container>
      <FileTypeIcon ext={fileInfo.extension} size="s20" />
    </Container>
  );
};

const Container = styled.div`
  width: 28px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${COLORS.systemDark200};
  color: ${COLORS.systemLight100};
`;
